interface EnvConfig {
  defaultApiKey: string;
  workspaceId: string;
  example: {
    taskId: string;
    docId: string;
    pageId: string;
  };
  chatGptApiKey: string;
}

export const env: EnvConfig = {
  defaultApiKey: import.meta.env.VITE_CLICKUP_DEFAULT_API_KEY || '',
  workspaceId: import.meta.env.VITE_CLICKUP_WORKSPACE_ID || '',
  example: {
    taskId: import.meta.env.VITE_CLICKUP_EXAMPLE_TASK_ID || '',
    docId: import.meta.env.VITE_CLICKUP_EXAMPLE_DOC_ID || '',
    pageId: import.meta.env.VITE_CLICKUP_EXAMPLE_PAGE_ID || '',
  },
  chatGptApiKey: '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',
};